import { Box, Text } from "@shared/primitive-components"
import { MaybeObfuscatedValue } from "../../../../components/Obfuscated"
import { rebatesStyles as styles } from "../../../styles"
import { VehicleData } from "../../../types"

type Props = {
  value: VehicleData
  dataTestIds?: {
    VRN: string
    NAME: string
  }
}
export const VehicleCell = ({ value, dataTestIds }: Props) => (
  <Box css={styles.marginY(2)}>
    <Text data-testid={dataTestIds?.VRN}>
      <MaybeObfuscatedValue type="vrn" value={value.vrn} />
    </Text>
    {value.name && (
      <Text data-testid={dataTestIds?.NAME} use="body2">
        {value.name}
      </Text>
    )}
  </Box>
)

VehicleCell.defaultProps = {
  dataTestIds: undefined,
}
